/**
 * SubmitErrorAlert — inline error alert shown when an order create call
 * fails (or when the 2FA window expired mid-checkout). Renders the
 * `submitError` string + an optional "Comprar créditos PM" CTA when the
 * error mentions insufficient credits (PR #1005 UX-3).
 *
 * SPEC-244 · partición VERBATIM de
 * frontend/src/components/market/checkout-modal.tsx (2.637 L).
 *
 * Preserved VERBATIM — the same JSX block appeared 8 times in the
 * original monolith (3× in physical, 3× in service, 2× in digital).
 */

import { AlertCircle, ArrowRight } from 'lucide-react';

// ─── Component ───────────────────────────────────────────────────────────────

export interface SubmitErrorAlertProps {
  /** The error message to render. */
  submitError: string;
}

export function SubmitErrorAlert({ submitError }: SubmitErrorAlertProps) {
  return (
    <div
      className="flex items-start gap-2 p-3 rounded-md border border-destructive/40 bg-destructive/10 text-sm text-destructive"
      role="alert"
    >
      <AlertCircle className="h-4 w-4 shrink-0 mt-0.5" />
      <div className="flex-1">
        <span>{submitError}</span>
        {/* PR #1005 (UX-3): CTA to buy credits PM when insufficient */}
        {submitError.includes('créditos suficientes') && (
          <a
            href="/market/comprar/credits"
            className="mt-2 inline-flex items-center gap-1 rounded-md bg-primary px-3 py-1.5 text-xs font-semibold text-primary-foreground hover:opacity-90 transition-opacity"
          >
            Comprar créditos PM
            <ArrowRight className="size-3" aria-hidden="true" />
          </a>
        )}
      </div>
    </div>
  );
}
